import { ItemsViewLayout } from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { YoutubeBroadcastItemSize } from '../broadcasts/item/YoutubeBroadcastItem';

/** Maps status screen layout to panorama strip broadcast card density. */
export function getYoutubePanoramaBroadcastItemSize(
  view: ItemsViewLayout,
): YoutubeBroadcastItemSize {
  if (view === 'list') {
    return 'large';
  }

  if (view === 'gridWide') {
    return 'medium';
  }

  if (view === 'gridCompact') {
    return 'xsmall';
  }

  return 'small';
}
